export const styles = theme => ({
  button: {
    width: '100%',
    display: 'flex',
    margin: 'auto'
  },
  
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})



// WEBPACK FOOTER //
// ./src/components/Users/components/CreateUserForm/styles.js